import { ShippingMethodEnum } from '../../shared/paymentTypes';
import { isBox } from '../../shared/product-safeguards';
import { type Product } from '../../shared/types';

function getShippingMethodForBuyNow(product: Product): ShippingMethodEnum {
    if (isBox(product)) {
        return ShippingMethodEnum.Standard;
    }

    return ShippingMethodEnum.Online;
}

export { getShippingMethodForBuyNow };
